"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as i } from "react";
import r from "../components/Icon/SvgIcon.js";
const s = (t) => /* @__PURE__ */ o(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...t,
    children: /* @__PURE__ */ o("rect", { width: 20, height: 2, x: 2, y: 11, fill: "currentColor", rx: 1 })
  }
), n = i(s);
export {
  n as QuickActionsIos,
  n as default
};
